import systemPreference from '@/screens/systemPreference/List'
import auth from './middleware/auth'

export default [
  {
    path: '/system-preference',
    component: systemPreference,
    name: 'System preference',
    meta: {
      requireAuth: true,
      permissions: ['manager', 'buyer', 'provider'],
      middleware: { auth }
    }
  }
]
